import { Service } from "@front-apps/core/services/Service"
import LinkAPI from "../API/link"
import StoreService from "@front-apps/core/services/store"

class LinkService extends Service {
    private static instance: LinkService

    constructor() {
        super()
        // set le nom du service
        this.name = "LinkService"
        // ajoute toute les methodes du service au tableau de mapping
        this.serviceMap = [
            { key: "createShortLink", fct: this.createShortLink },
        ]
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): LinkService {
        if (!this.instance) {
            this.instance = new LinkService()
        }
        return this.instance
    }

    public async createShortLink(groupId: string, pdv?: string): Promise<void> {
        const tram = await StoreService.getInstance().persistant.get(
            "groupTram"
        )
        const shortLink = await LinkAPI.createShortLink(tram, groupId, pdv || 0)
        await StoreService.getInstance().persistant.set("shortLink", shortLink)
    }
}

export default LinkService
